import axios from 'axios';

import ComercialTabla from '../types/ComercialTabla';


async function GuardarAgenteComercial(prmComercial: ComercialTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_comercial"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "comercial": {
                "id": prmComercial.id,
                "cuit": prmComercial.cuit,
                "nombrefan": prmComercial.nombrefantasia,
                "codigo": prmComercial.codigo,
                "apellido": prmComercial.apellido,
                "nombres": prmComercial.nombres,
                "domicilio": prmComercial.domicilio,
                "telefono": prmComercial.telefono,
                "celular": prmComercial.celular,
                "email": prmComercial.email,
                "habilitado": prmComercial.habilitado,
                "fch_modi": prmComercial.fecha_modificacion,
                "dado_baja": prmComercial.dado_de_baja,
                "fch_baja": prmComercial.fecha_baja,
                "idpais": prmComercial.idpais,
                "idprovincia": prmComercial.idprovincia,
                "idlocalidad": prmComercial.idlocalidad,
                "observaciones": prmComercial.observaciones
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarAgenteComercial;